var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"v-m-milestone-mini badge badge-primary"},[_vm._v("M"+_vm._s(_vm.m.m_ident))])}
var staticRenderFns = []

export { render, staticRenderFns }